import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models';
import { FormOption } from '@shared/forms';
import { DepartmentDto, IdNameDto } from '@app/store/shared/models';
import { Departments, GetDepartmentsLookupValue, GetDepartmentsLookupValueDto, GetDepartmentsValue, GetDepartmentsValueDto } from '../models';

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getDepartments(value: GetDepartmentsValue): Observable<Departments> {
        const params = new GetDepartmentsValueDto(value).toHttpParams();

        return this.httpClient.get<ApiResponse<DepartmentDto[]>>('v1/admin/departments', { params }).pipe(mapDto((response) => new Departments(response)));
    }

    getDepartmentsLookup(value: GetDepartmentsLookupValue): Observable<FormOption<string>[]> {
        const params = new GetDepartmentsLookupValueDto(value).toHttpParams();

        return this.httpClient
            .get<ApiResponse<IdNameDto[]>>('v1/admin/departments/lookup', { params })
            .pipe(mapDto((response) => response.data.map((dto) => ({ label: dto.name, value: dto.id }))));
    }
}
